import { ACTION_CREATE, ACTION_VIEW, ACTION_EDIT, ACTION_DELETE, ACTION_ANY, ACTION_ALL } from '../request';

const TOTAL_ACTIONS = ACTION_ALL.length;
const ALL_ACCESS = {
    [ACTION_CREATE]: true,
    [ACTION_VIEW]: true,
    [ACTION_EDIT]: true,
    [ACTION_DELETE]: true,
};

export class Resource {
    /**
     * @param {string} name
     * @param {{[string]: boolean}} access
     */
    constructor(name, access) {
        this.name = name;
        this.access = access || { ...ALL_ACCESS };
        this._any = null;
    }

    /**
     * @param {Resource} resource
     * @returns {this}
     */
    merge(resource) {
        Object.assign(this.access, resource.access);
        this._any = null;

        return this;
    }

    get grantsAny() {
        if (this._any === null) {
            let total = 0;

            for (const value of Object.values(this.access)) {
                total++;

                if (value) {
                    this._any = true;

                    return true;
                }
            }

            this._any = total === TOTAL_ACTIONS ? false : undefined;
        }

        return this._any;
    }

    /**
     * @param {string} action
     * @returns {boolean}
     */
    isGranted(action) {
        return action === ACTION_ANY ? this.grantsAny : this.access[action];
    }
}
